import { Component, OnInit } from '@angular/core';

import { RouterQuery } from '@datorama/akita-ng-router-store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { BillingUxService, ServiceLogUxService } from '../services';

@UntilDestroy()
@Component({
  selector: 'app-billing-shell',
  template: `
    <nav mat-tab-nav-bar>
      <a
        mat-tab-link
        *ngFor="let link of links"
        [routerLink]="[link.route]"
        (click)="activeLink = link.route"
        [active]="link.route == activeLink"
      >
        {{ link.label }}
      </a>
    </nav>
    <router-outlet></router-outlet>
  `,
  styles: [],
})
export class BillingShellComponent implements OnInit {
  activeLink: string | undefined;
  links = [
    {
      label: 'Unprocessed',
      route: 'unprocessed',
    },
    {
      label: 'Submitted',
      route: 'submitted',
    },
  ];

  constructor(
    private routerQuery: RouterQuery,
    private serviceUx: ServiceLogUxService,
    private billingUx: BillingUxService
  ) {}

  ngOnInit(): void {
    this.routerQuery
      .select()
      .pipe(untilDestroyed(this))
      .subscribe(val => {
        this.activeLink = val.state?.urlAfterRedirects.includes('unprocessed')
          ? 'unprocessed'
          : 'submitted';
      });
    this.serviceUx.syncForBilling().pipe(untilDestroyed(this)).subscribe();
    this.billingUx.sync().pipe(untilDestroyed(this)).subscribe();
  }
}
